import React from 'react';
import Main from './Main';
import FactListContainer from '../containers/FactListContainer';
import Scale from './Scale';
import './Facts.css';

export default () => {
  return (
    <Main>
      <div className="facts-content">
        <section className="section facts">
          <h2 className="section-title">Verificación de datos</h2>
          <div className="facts-grid">
            <div className="legend">
              <h3 className="legend__title">Rango de verificación</h3>
              <div className="legend__scales">
                <Scale id="5" type="legend" />
                <Scale id="4" type="legend" />
                <Scale id="3" type="legend" />
                <Scale id="2" type="legend" />
                <Scale id="1" type="legend" />
              </div>
            </div>
            <FactListContainer />
          </div>
        </section>
      </div>
    </Main>
  );
};



// WEBPACK FOOTER //
// ./src/components/Facts.js